import { gunterzBold } from '@/theme/fonts';
import { Card, NumberFormatter, Text } from '@mantine/core';
export type ReferralMetricProps = {
  title: string;
  metricValue: number;
  suffix?: string | undefined;
};
export const ReferralMetric: React.FC<ReferralMetricProps> = ({
  title,
  metricValue,
  suffix
}) => {
  return <Card radius={5} bg="var(--navbar-bg-color)" px={{
    base: 10,
    sm: 20
  }} py={{
    base: 20,
    sm: 24
  }}>
      <Text fw={700} fz={12} c="var(--text-prime)" tt="uppercase">
        {title}
      </Text>
      <Text fz={20} className={gunterzBold.className} mt={10}>
        <NumberFormatter value={metricValue} thousandSeparator="," decimalSeparator="." decimalScale={2} suffix={suffix} />
      </Text>
    </Card>;
};